module.exports = __webpack_public_path__ + "img/logo-pix.2f22da87.png";